import { Routes } from '@angular/router';
import { DISPLAY_BREADCRUMBS, PATH_ROUTING } from 'src/app/shared/enums/routing-enums';
import { USERTYPE } from 'src/app/core/enums/routing-item.enum';
import { RSP_ROLES, CONTRACT_ROLES, DOCSTORE_ROLES } from './../../../../shared/enums/admin-enum';
import { UserRolePermissionGuard } from 'src/app/core/guards/user-router-permission.guard';
import { GeneralSettingsComponent } from './admin/general-settings/general-settings.component';
import { CreateEditContractAccessComponent } from './admin/create-edit-contract-access/create-edit-contract-access.component';
import { NewsDashboardComponent } from '../news-dashboard/news-dashboard.component';
import { AdminSRMComponent } from './admin/admin-srm/admin-srm.component';
import { AdminComponent } from './admin/admin/admin.component';
import { TrainingDocumentDetailComponent } from './admin/admin/training-document-detail/training-document-detail.component';
import { ApplicationAccessStatusComponent } from './admin/application-access-status/application-access-status.component';
import { ApplicationLinkContainerComponent } from './admin/application-link-container/application-link-container.component';
import { AssignmentGroupManagementComponent } from './admin/assignment-group-management/assignment-group-management.component';
import { ContractAccessComponent } from './admin/contract-access/contract-access.component';
import { CreateEditApplicationLinkComponent } from './admin/create-edit-application-link/create-edit-application-link.component';
import { CreateEditNewsComponent } from './admin/create-edit-news/create-edit-news.component';
import { CreateEditRoleComponent } from './admin/create-edit-role/create-edit-role.component';
import { CreateEditScorecardSettingComponent } from './admin/create-edit-scorecard-setting/create-edit-scorecard-setting.component';
import { CreateEditSectionComponent } from './admin/create-edit-section/create-edit-section.component';
import { CreateEditStayInformedComponent } from './admin/create-edit-stay-informed/create-edit-stay-informed.component';
import { CreateEditSupplierUserComponent } from './admin/create-edit-supplier-user/create-edit-supplier-user.component';
import { NewsComponent } from './admin/news/news.component';
import { RevokeAccessComponent } from './admin/revoke-access/revoke-access.component';
import { RoleComponent } from './admin/role/role.component';
import { ScorecardSettingComponent } from './admin/scorecard-setting/scorecard-setting.component';
import { SectionManagementComponent } from './admin/section-management/section-management.component';
import { StayInformedAdminComponent } from './admin/stay-informed-admin/stay-informed-admin.component';
import { SupplierUserContainerComponent } from './admin/supplier-user-container/supplier-user-container.component';
import { WelcomeMessageComponent } from './admin/welcome-message/welcome-message.component';
import { LandingPageComponent } from './landing-page/landing-page.component';
import { ScoreCardComponent } from './score-card/score-card.component';
import { DocStoreAccessComponent } from './admin/docstore-access/docstore-access.component';
import { CreateEditDocStoreAccessComponent } from './admin/create-edit-docstore-access/create-edit-docstore-access.component';
import { GeTagStatusesComponent } from './admin/ge-tag-statuses/ge-tag-statuses.component';
import { GeTagStatusUpdateComponent } from './admin/ge-tag-status-update/ge-tag-status-update.component';
import { EolSetupsComponent } from './admin/eol-setups/eol-setups.component';
import { EolSetupsFormComponent } from './admin/eol-setups-form/eol-setups-form.component';


export const SRM_ROUTING: Routes = [
  {
    path: '',
    redirectTo: PATH_ROUTING.PATH_SRM_HOME_PAGE,
    pathMatch: 'full'
  },
  {
    path: PATH_ROUTING.PATH_SRM_HOME_PAGE,
    component: LandingPageComponent,
    data: {
      permissionCodes: [RSP_ROLES.ADMIN, RSP_ROLES.SUPER_USER, RSP_ROLES.OPERATOR_ACCESS, RSP_ROLES.OPERATOR_INFO,
        RSP_ROLES.SUPPLIER, RSP_ROLES.INTERNAL_USER, RSP_ROLES.GE_TAG_ID_ADMIN]
    },
    canActivate: [UserRolePermissionGuard]
  },
  {
    path: PATH_ROUTING.PATH_NEWS,
    component: NewsDashboardComponent,
    data: {
      permissionCodes: [RSP_ROLES.ADMIN, RSP_ROLES.SUPER_USER, RSP_ROLES.OPERATOR_ACCESS, RSP_ROLES.OPERATOR_INFO,
        RSP_ROLES.SUPPLIER, RSP_ROLES.INTERNAL_USER]
    },
    canActivate: [UserRolePermissionGuard]
  },
  {
    path: PATH_ROUTING.PATH_SCORECARD,
    component: ScoreCardComponent,
    data: {
      permissionCodes: [RSP_ROLES.ADMIN, RSP_ROLES.SUPER_USER, RSP_ROLES.OPERATOR_ACCESS, RSP_ROLES.OPERATOR_INFO,
        RSP_ROLES.SUPPLIER, RSP_ROLES.INTERNAL_USER]
    },
    canActivate: [UserRolePermissionGuard]
  },
  {
    path: PATH_ROUTING.PATH_NEWS_ID,
    component: NewsDashboardComponent,
    data: {
      permissionCodes: [RSP_ROLES.ADMIN, RSP_ROLES.SUPER_USER, RSP_ROLES.OPERATOR_ACCESS, RSP_ROLES.OPERATOR_INFO,
        RSP_ROLES.SUPPLIER, RSP_ROLES.INTERNAL_USER]
    },
    canActivate: [UserRolePermissionGuard]
  },
  {
    path: PATH_ROUTING.PATH_ADMIN,
    component: AdminSRMComponent,
    children: [
      // {
      //   path: '',
      //   redirectTo: PATH_ROUTING.PATH_WELCOME_MESSAGE,
      //   pathMatch: 'full',
      // },
      {
        path: PATH_ROUTING.PATH_WELCOME_MESSAGE,
        component: WelcomeMessageComponent,
        data: {
          permissionCodes: [RSP_ROLES.ADMIN, RSP_ROLES.SUPER_USER, RSP_ROLES.OPERATOR_INFO, RSP_ROLES.GE_TAG_ID_ADMIN]
        },
        canActivate: [UserRolePermissionGuard]
      },
      {
        path: PATH_ROUTING.PATH_SECTION,
        component: SectionManagementComponent,
        data: {
          breadcrumbs: [
            { display: DISPLAY_BREADCRUMBS.SRM, url: PATH_ROUTING.PATH_SRM + '/' + PATH_ROUTING.PATH_ADMIN },
            { display: DISPLAY_BREADCRUMBS.SECTION, url: '' },
          ],
          permissionCodes: [RSP_ROLES.ADMIN, RSP_ROLES.SUPER_USER, RSP_ROLES.OPERATOR_INFO]
        },
        canActivate: [UserRolePermissionGuard]
      },
      {
        path: PATH_ROUTING.PATH_ADD_SECTION,
        component: CreateEditSectionComponent,
        data: {
          breadcrumbs: [
            { display: DISPLAY_BREADCRUMBS.SRM, url: PATH_ROUTING.PATH_SRM + '/' + PATH_ROUTING.PATH_ADMIN },
            { display: DISPLAY_BREADCRUMBS.SECTION, url: '/' + PATH_ROUTING.PATH_SRM + '/' + PATH_ROUTING.PATH_ADMIN
             + '/' + PATH_ROUTING.PATH_SECTION },
            { display: DISPLAY_BREADCRUMBS.ADD_SECTION, url: '' },
          ],
          permissionCodes: [RSP_ROLES.ADMIN, RSP_ROLES.SUPER_USER, RSP_ROLES.OPERATOR_INFO]
        },
        canActivate: [UserRolePermissionGuard]
      },
      {
        path: PATH_ROUTING.PATH_EDIT_SECTION,
        component: CreateEditSectionComponent,
        data: {
          breadcrumbs: [
            { display: DISPLAY_BREADCRUMBS.SRM, url: PATH_ROUTING.PATH_SRM + '/' + PATH_ROUTING.PATH_ADMIN },
            { display: DISPLAY_BREADCRUMBS.SECTION, url: '/' + PATH_ROUTING.PATH_SRM + '/' + PATH_ROUTING.PATH_ADMIN
             + '/' + PATH_ROUTING.PATH_SECTION },
            { display: DISPLAY_BREADCRUMBS.EDIT_SECTION, url: '' },
          ],
          permissionCodes: [RSP_ROLES.ADMIN, RSP_ROLES.SUPER_USER, RSP_ROLES.OPERATOR_INFO]
        },
        canActivate: [UserRolePermissionGuard]
      },
      {
        path: PATH_ROUTING.PATH_APPLICATION_LINK,
        component: ApplicationLinkContainerComponent,
        data: {
          breadcrumbs: [
            { display: DISPLAY_BREADCRUMBS.SRM, url: PATH_ROUTING.PATH_SRM + '/' + PATH_ROUTING.PATH_ADMIN },
            { display: DISPLAY_BREADCRUMBS.SECTION, url: '/' + PATH_ROUTING.PATH_SRM + '/' +
            PATH_ROUTING.PATH_ADMIN + '/' + PATH_ROUTING.PATH_SECTION },
            { display: DISPLAY_BREADCRUMBS.APPLICATION, url: '' },
          ],
          permissionCodes: [RSP_ROLES.ADMIN, RSP_ROLES.SUPER_USER, RSP_ROLES.OPERATOR_INFO]
        },
        canActivate: [UserRolePermissionGuard]
      },
      {
        path: PATH_ROUTING.PATH_ADD_APPLICATION_LINK,
        component: CreateEditApplicationLinkComponent,
        data: {
          breadcrumbs: [
            { display: DISPLAY_BREADCRUMBS.SRM, url: PATH_ROUTING.PATH_SRM + '/' + PATH_ROUTING.PATH_ADMIN },
            { display: DISPLAY_BREADCRUMBS.SECTION, url: '/' + PATH_ROUTING.PATH_SRM + '/' +
             PATH_ROUTING.PATH_ADMIN + '/' + PATH_ROUTING.PATH_SECTION },
            { display: DISPLAY_BREADCRUMBS.APPLICATION, url: '' },
          ],
          permissionCodes: [RSP_ROLES.ADMIN, RSP_ROLES.SUPER_USER, RSP_ROLES.OPERATOR_INFO]
        },
        canActivate: [UserRolePermissionGuard]
      },
      {
        path: PATH_ROUTING.PATH_EDIT_APPLICATION_LINK,
        component: CreateEditApplicationLinkComponent,
        data: {
          breadcrumbs: [
            { display: DISPLAY_BREADCRUMBS.SRM, url: PATH_ROUTING.PATH_ADMIN },
            { display: DISPLAY_BREADCRUMBS.SECTION, url: '/' + PATH_ROUTING.PATH_SRM + '/' +
             PATH_ROUTING.PATH_ADMIN + '/' + PATH_ROUTING.PATH_SECTION },
            { display: DISPLAY_BREADCRUMBS.APPLICATION, url: '' },
          ],
          permissionCodes: [RSP_ROLES.ADMIN, RSP_ROLES.SUPER_USER, RSP_ROLES.OPERATOR_INFO]
        },
        canActivate: [UserRolePermissionGuard]
      },
      {
        path: PATH_ROUTING.PATH_SUPPIER_USER,
        component: SupplierUserContainerComponent,
        data: {
          breadcrumbs: [
            { display: DISPLAY_BREADCRUMBS.SRM, url: PATH_ROUTING.PATH_SRM + '/' + PATH_ROUTING.PATH_ADMIN },
            { display: DISPLAY_BREADCRUMBS.SUPPLIER_USER_MANAGEMENT, url: '' }
          ],
          type: USERTYPE.SUPPLIER_USER,
          permissionCodes: [RSP_ROLES.ADMIN, RSP_ROLES.SUPER_USER, RSP_ROLES.OPERATOR_ACCESS, RSP_ROLES.EOL_ADMIN]
        },
        canActivate: [UserRolePermissionGuard]
      },
      {
        path: PATH_ROUTING.PATH_ADD_SUPPIER_USER,
        component: CreateEditSupplierUserComponent,
        data: {
          breadcrumbs: [
            { display: DISPLAY_BREADCRUMBS.SRM, url: PATH_ROUTING.PATH_SRM + '/' + PATH_ROUTING.PATH_ADMIN },
            {
              display: DISPLAY_BREADCRUMBS.SUPPLIER_USER_MANAGEMENT,
              url: '/' + PATH_ROUTING.PATH_SRM + '/' + PATH_ROUTING.PATH_ADMIN + '/' + PATH_ROUTING.PATH_SUPPIER_USER
            },
            { display: DISPLAY_BREADCRUMBS.ADD_SUPPLIER_USER, url: '' }
          ],
          type: USERTYPE.SUPPLIER_USER,
          permissionCodes: [RSP_ROLES.ADMIN, RSP_ROLES.SUPER_USER, RSP_ROLES.OPERATOR_ACCESS, RSP_ROLES.EOL_ADMIN]
        },
        canActivate: [UserRolePermissionGuard]
      },
      {
        path: PATH_ROUTING.PATH_EDIT_SUPPIER_USER,
        component: CreateEditSupplierUserComponent,
        data: {
          breadcrumbs: [
            { display: DISPLAY_BREADCRUMBS.SRM, url: PATH_ROUTING.PATH_SRM + '/' + PATH_ROUTING.PATH_ADMIN },
            {
              display: DISPLAY_BREADCRUMBS.SUPPLIER_USER_MANAGEMENT,
              url: '/' + PATH_ROUTING.PATH_SRM + '/' + PATH_ROUTING.PATH_ADMIN + '/' + PATH_ROUTING.PATH_SUPPIER_USER
            },
            { display: DISPLAY_BREADCRUMBS.EDIT_SUPPLIER_USER, url: '' }
          ],
          type: USERTYPE.SUPPLIER_USER,
          permissionCodes: [RSP_ROLES.ADMIN, RSP_ROLES.SUPER_USER, RSP_ROLES.OPERATOR_ACCESS, RSP_ROLES.EOL_ADMIN]
        },
        canActivate: [UserRolePermissionGuard]
      },
      {
        path: PATH_ROUTING.PATH_INTERNAL_USER,
        component: SupplierUserContainerComponent,
        data: {
          breadcrumbs: [
            { display: DISPLAY_BREADCRUMBS.SRM, url: PATH_ROUTING.PATH_SRM + '/' + PATH_ROUTING.PATH_ADMIN },
            { display: DISPLAY_BREADCRUMBS.INTERNAL_USER_USER, url: '' }
          ],
          type: USERTYPE.INTERNAL_USER,
          permissionCodes: [RSP_ROLES.ADMIN, RSP_ROLES.SUPER_USER, RSP_ROLES.OPERATOR_ACCESS]
        },
        canActivate: [UserRolePermissionGuard]
      },
      {
        path: PATH_ROUTING.PATH_ADD_INTERNAL_USER,
        component: CreateEditSupplierUserComponent,
        data: {
          breadcrumbs: [
            { display: DISPLAY_BREADCRUMBS.SRM, url: PATH_ROUTING.PATH_SRM + '/' +  PATH_ROUTING.PATH_ADMIN },
            {
              display: DISPLAY_BREADCRUMBS.INTERNAL_USER_USER, url: '/' + PATH_ROUTING.PATH_SRM + '/' + PATH_ROUTING.PATH_ADMIN +
                '/' + PATH_ROUTING.PATH_INTERNAL_USER
            },
            { display: DISPLAY_BREADCRUMBS.ADD_INTERNAL_USER, url: '' }
          ],
          type: USERTYPE.INTERNAL_USER,
          permissionCodes: [RSP_ROLES.ADMIN, RSP_ROLES.SUPER_USER, RSP_ROLES.OPERATOR_ACCESS]
        },
        canActivate: [UserRolePermissionGuard]
      },
      {
        path: PATH_ROUTING.PATH_EDIT_INTERNAL_USER,
        component: CreateEditSupplierUserComponent,
        data: {
          breadcrumbs: [
            { display: DISPLAY_BREADCRUMBS.SRM, url: PATH_ROUTING.PATH_SRM + '/' + PATH_ROUTING.PATH_ADMIN },
            {
              display: DISPLAY_BREADCRUMBS.INTERNAL_USER_USER, url: '/' + PATH_ROUTING.PATH_SRM + '/' + PATH_ROUTING.PATH_ADMIN +
                '/' + PATH_ROUTING.PATH_INTERNAL_USER
            },
            { display: DISPLAY_BREADCRUMBS.EDIT_INTERNAL_USER, url: '' }
          ],
          type: USERTYPE.INTERNAL_USER,
          permissionCodes: [RSP_ROLES.ADMIN, RSP_ROLES.SUPER_USER, RSP_ROLES.OPERATOR_ACCESS]
        },
        canActivate: [UserRolePermissionGuard]
      },
      {
        path: PATH_ROUTING.PATH_CONTRACT_ACCESS,
        component: ContractAccessComponent,
        data: {
          breadcrumbs: [
            { display: DISPLAY_BREADCRUMBS.SRM, url: PATH_ROUTING.PATH_SRM + '/' + PATH_ROUTING.PATH_ADMIN },
            { display: DISPLAY_BREADCRUMBS.CONTRACT_ACCESS, url: '' }
          ],
          type: USERTYPE.INTERNAL_USER,
          permissionCodes: [RSP_ROLES.ADMIN,CONTRACT_ROLES.CONTRACT_ADMIN]
        },
        canActivate: [UserRolePermissionGuard]
      },
      {
        path: PATH_ROUTING.PATH_ADD_CONTRACT_ROLE,
        component: CreateEditContractAccessComponent,
        data: {
          breadcrumbs: [
            { display: DISPLAY_BREADCRUMBS.SRM, url: PATH_ROUTING.PATH_SRM + '/' +  PATH_ROUTING.PATH_ADMIN },
            {
              display: DISPLAY_BREADCRUMBS.CONTRACT_ACCESS, url: '/' + PATH_ROUTING.PATH_SRM + '/' + PATH_ROUTING.PATH_ADMIN +
                '/' + PATH_ROUTING.PATH_CONTRACT_ACCESS
            },
            { display: DISPLAY_BREADCRUMBS.ADD_CONTRACT_ACCESS, url: '' }
          ],
          type: USERTYPE.INTERNAL_USER,
          permissionCodes: [RSP_ROLES.ADMIN, RSP_ROLES.SUPER_USER, RSP_ROLES.OPERATOR_ACCESS,
            CONTRACT_ROLES.CONTRACT_ADMIN, CONTRACT_ROLES.CONTRACT_VIEWER, CONTRACT_ROLES.CONTRACT_EDITOR]
        },
        canActivate: [UserRolePermissionGuard]
      },
      {
        path: PATH_ROUTING.PATH_EDIT_CONTRACT_ROLE,
        component: CreateEditContractAccessComponent,
        data: {
          breadcrumbs: [
            { display: DISPLAY_BREADCRUMBS.SRM, url: PATH_ROUTING.PATH_SRM + '/' + PATH_ROUTING.PATH_ADMIN },
            {
              display: DISPLAY_BREADCRUMBS.CONTRACT_ACCESS, url: '/' + PATH_ROUTING.PATH_SRM + '/' + PATH_ROUTING.PATH_ADMIN +
                '/' + PATH_ROUTING.PATH_CONTRACT_ACCESS
            },
            { display: DISPLAY_BREADCRUMBS.EDIT_CONTRACT_ACCESS, url: '' }
          ],
          type: USERTYPE.INTERNAL_USER,
          permissionCodes: [RSP_ROLES.ADMIN, RSP_ROLES.SUPER_USER, RSP_ROLES.OPERATOR_ACCESS,
            CONTRACT_ROLES.CONTRACT_ADMIN, CONTRACT_ROLES.CONTRACT_VIEWER, CONTRACT_ROLES.CONTRACT_EDITOR]
        },
        canActivate: [UserRolePermissionGuard]
      },
      {
        path: PATH_ROUTING.PATH_DOCSTORE_ACCESS,
        component: DocStoreAccessComponent,
        data: {
          breadcrumbs: [
            { display: DISPLAY_BREADCRUMBS.SRM, url: PATH_ROUTING.PATH_SRM + '/' + PATH_ROUTING.PATH_ADMIN },
            { display: DISPLAY_BREADCRUMBS.DOCSTORE_ACCESS, url: '' }
          ],
          type: USERTYPE.INTERNAL_USER,
          permissionCodes: [RSP_ROLES.ADMIN, DOCSTORE_ROLES.DOCSTORE_ADMIN]
        },
        canActivate: [UserRolePermissionGuard]
      },
      {
        path: PATH_ROUTING.PATH_ADD_DOCSTORE_ROLE,
        component: CreateEditDocStoreAccessComponent,
        data: {
          breadcrumbs: [
            { display: DISPLAY_BREADCRUMBS.SRM, url: PATH_ROUTING.PATH_SRM + '/' +  PATH_ROUTING.PATH_ADMIN },
            {
              display: DISPLAY_BREADCRUMBS.DOCSTORE_ACCESS, url: '/' + PATH_ROUTING.PATH_SRM + '/' + PATH_ROUTING.PATH_ADMIN +
                '/' + PATH_ROUTING.PATH_DOCSTORE_ACCESS
            },
            { display: DISPLAY_BREADCRUMBS.ADD_DOCSTORE_ACCESS, url: '' }
          ],
          type: USERTYPE.INTERNAL_USER,
          permissionCodes: [RSP_ROLES.ADMIN, RSP_ROLES.SUPER_USER, RSP_ROLES.OPERATOR_ACCESS,
            DOCSTORE_ROLES.DOCSTORE_ADMIN, DOCSTORE_ROLES.DOCSTORE_VIEWER, DOCSTORE_ROLES.DOCSTORE_EDITOR]
        },
        canActivate: [UserRolePermissionGuard]
      },
      {
        path: PATH_ROUTING.PATH_EDIT_DOCSTORE_ROLE,
        component: CreateEditDocStoreAccessComponent,
        data: {
          breadcrumbs: [
            { display: DISPLAY_BREADCRUMBS.SRM, url: PATH_ROUTING.PATH_SRM + '/' + PATH_ROUTING.PATH_ADMIN },
            {
              display: DISPLAY_BREADCRUMBS.DOCSTORE_ACCESS, url: '/' + PATH_ROUTING.PATH_SRM + '/' + PATH_ROUTING.PATH_ADMIN +
                '/' + PATH_ROUTING.PATH_DOCSTORE_ACCESS
            },
            { display: DISPLAY_BREADCRUMBS.EDIT_DOCSTORE_ACCESS, url: '' }
          ],
          type: USERTYPE.INTERNAL_USER,
          permissionCodes: [RSP_ROLES.ADMIN, RSP_ROLES.SUPER_USER, RSP_ROLES.OPERATOR_ACCESS,
            DOCSTORE_ROLES.DOCSTORE_ADMIN, DOCSTORE_ROLES.DOCSTORE_VIEWER, DOCSTORE_ROLES.DOCSTORE_EDITOR]
        },
        canActivate: [UserRolePermissionGuard]
      },
      {
        path: PATH_ROUTING.PATH_NEWS,
        component: NewsComponent,
        data: {
          breadcrumbs: [
            { display: DISPLAY_BREADCRUMBS.SRM, url: PATH_ROUTING.PATH_SRM + '/' + PATH_ROUTING.PATH_ADMIN },
            { display: DISPLAY_BREADCRUMBS.NEWS, url: '' }
          ],
          permissionCodes: [RSP_ROLES.ADMIN, RSP_ROLES.SUPER_USER, RSP_ROLES.OPERATOR_INFO]
        },
        canActivate: [UserRolePermissionGuard]
      },
      {
        path: PATH_ROUTING.PATH_ADD_NEWS,
        component: CreateEditNewsComponent,
        data: {
          breadcrumbs: [
            { display: DISPLAY_BREADCRUMBS.SRM, url: PATH_ROUTING.PATH_SRM + '/' + PATH_ROUTING.PATH_ADMIN },
            { display: DISPLAY_BREADCRUMBS.NEWS, url: '/' + PATH_ROUTING.PATH_SRM + '/' + PATH_ROUTING.PATH_ADMIN +
            '/' + PATH_ROUTING.PATH_NEWS },
            { display: DISPLAY_BREADCRUMBS.ADD_NEWS, url: '' },
          ],
          permissionCodes: [RSP_ROLES.ADMIN, RSP_ROLES.SUPER_USER, RSP_ROLES.OPERATOR_INFO]
        },
        canActivate: [UserRolePermissionGuard]
      },
      {
        path: PATH_ROUTING.PATH_EDIT_NEWS,
        component: CreateEditNewsComponent,
        data: {
          breadcrumbs: [
            { display: DISPLAY_BREADCRUMBS.SRM, url: PATH_ROUTING.PATH_SRM + '/' + PATH_ROUTING.PATH_ADMIN },
            { display: DISPLAY_BREADCRUMBS.NEWS, url: '/' + PATH_ROUTING.PATH_SRM + '/' + PATH_ROUTING.PATH_ADMIN
            + '/' + PATH_ROUTING.PATH_NEWS },
            { display: DISPLAY_BREADCRUMBS.EDIT_NEWS, url: '' },
          ],
          permissionCodes: [RSP_ROLES.ADMIN, RSP_ROLES.SUPER_USER, RSP_ROLES.OPERATOR_INFO]
        },
        canActivate: [UserRolePermissionGuard]
      },
      {
        path: PATH_ROUTING.PATH_APPICATION_ACCESS_STATUS,
        component: ApplicationAccessStatusComponent,
        data: {
          breadcrumbs: [
            { display: DISPLAY_BREADCRUMBS.SRM, url: PATH_ROUTING.PATH_SRM + '/' + PATH_ROUTING.PATH_ADMIN },
            { display: DISPLAY_BREADCRUMBS.APPLICATION_ACCESS_STATUS, url: '' },
          ],
          permissionCodes: [RSP_ROLES.ADMIN, RSP_ROLES.SUPER_USER, RSP_ROLES.OPERATOR_ACCESS]
        },
        canActivate: [UserRolePermissionGuard]
      },
      {
        path: PATH_ROUTING.PATH_REVOKE_ACCESS,
        component: RevokeAccessComponent,
        data: {
          breadcrumbs: [
            { display: DISPLAY_BREADCRUMBS.SRM, url: PATH_ROUTING.PATH_SRM + '/' + PATH_ROUTING.PATH_ADMIN },
            { display: DISPLAY_BREADCRUMBS.APPLICATION_ACCESS_STATUS, url: PATH_ROUTING.PATH_SRM + '/' + PATH_ROUTING.PATH_ADMIN
          + '/' + PATH_ROUTING.PATH_APPICATION_ACCESS_STATUS },
          { display: DISPLAY_BREADCRUMBS.REVOKE_ACCESS, url: '' },
          ],
          permissionCodes: [RSP_ROLES.ADMIN, RSP_ROLES.SUPER_USER, RSP_ROLES.OPERATOR_ACCESS]
        },
        canActivate: [UserRolePermissionGuard]
      },
      {
        path: PATH_ROUTING.PATH_REVOKE_ACCESS_ID,
        component: RevokeAccessComponent,
        data: {
          breadcrumbs: [
            { display: DISPLAY_BREADCRUMBS.SRM, url: PATH_ROUTING.PATH_SRM + '/' + PATH_ROUTING.PATH_ADMIN },
            { display: DISPLAY_BREADCRUMBS.APPLICATION_ACCESS_STATUS, url: PATH_ROUTING.PATH_SRM + '/' + PATH_ROUTING.PATH_ADMIN
          + '/' + PATH_ROUTING.PATH_APPICATION_ACCESS_STATUS },
          { display: DISPLAY_BREADCRUMBS.REVOKE_ACCESS, url: '' },
          ],
          permissionCodes: [RSP_ROLES.ADMIN, RSP_ROLES.SUPER_USER, RSP_ROLES.OPERATOR_ACCESS]
        },
        canActivate: [UserRolePermissionGuard]
      },
      {
        path: PATH_ROUTING.PATH_ROLES,
        component: RoleComponent,
        data: {
          breadcrumbs: [
            { display: DISPLAY_BREADCRUMBS.SRM, url: PATH_ROUTING.PATH_SRM + '/' + PATH_ROUTING.PATH_ADMIN },
          { display: DISPLAY_BREADCRUMBS.ROLE, url: '' },
          ],
          permissionCodes: [RSP_ROLES.ADMIN, RSP_ROLES.SUPER_USER]
        },
        canActivate: [UserRolePermissionGuard]
      },
      {
        path: PATH_ROUTING.PATH_ADD_ROLE,
        component: CreateEditRoleComponent,
        data: {
          breadcrumbs: [
            { display: DISPLAY_BREADCRUMBS.SRM, url: PATH_ROUTING.PATH_SRM + '/' + PATH_ROUTING.PATH_ADMIN },
            { display: DISPLAY_BREADCRUMBS.ROLE, url: PATH_ROUTING.PATH_SRM + '/' + PATH_ROUTING.PATH_ADMIN
          + '/' + PATH_ROUTING.PATH_ROLES },
          { display: DISPLAY_BREADCRUMBS.ADD_ROLE, url: '' },
          ],
          permissionCodes: [RSP_ROLES.ADMIN, RSP_ROLES.SUPER_USER]
        },
        canActivate: [UserRolePermissionGuard]
      },
      {
        path: PATH_ROUTING.PATH_EDIT_ROLE,
        component: CreateEditRoleComponent,
        data: {
          breadcrumbs: [
            { display: DISPLAY_BREADCRUMBS.SRM, url: PATH_ROUTING.PATH_SRM + '/' + PATH_ROUTING.PATH_ADMIN },
            { display: DISPLAY_BREADCRUMBS.ROLE, url: PATH_ROUTING.PATH_SRM + '/' + PATH_ROUTING.PATH_ADMIN
          + '/' + PATH_ROUTING.PATH_ROLES },
          { display: DISPLAY_BREADCRUMBS.EDIT_ROLE, url: '' },
          ],
          permissionCodes: [RSP_ROLES.ADMIN, RSP_ROLES.SUPER_USER]
        },
        canActivate: [UserRolePermissionGuard]
      },
      {
        path: PATH_ROUTING.PATH_GE_ADMIN_STATUES,
        component: GeTagStatusesComponent,
        data: {
          breadcrumbs: [
            { display: DISPLAY_BREADCRUMBS.SRM, url: PATH_ROUTING.PATH_SRM + '/' + PATH_ROUTING.PATH_ADMIN },
            { display: DISPLAY_BREADCRUMBS.GE_ADMIN_STATUES, url: '' },
          ],
        permissionCodes: [RSP_ROLES.ADMIN, RSP_ROLES.GE_TAG_ID_ADMIN, RSP_ROLES.SUPER_USER]
        },
        canActivate: [UserRolePermissionGuard]
      },
      {
        path: PATH_ROUTING.PATH_GE_ADMIN_STATUS_UPDATE,
        component: GeTagStatusUpdateComponent,
        data: {
          breadcrumbs: [
            { display: DISPLAY_BREADCRUMBS.SRM, url: PATH_ROUTING.PATH_SRM + '/' + PATH_ROUTING.PATH_ADMIN },
            { display: DISPLAY_BREADCRUMBS.GE_ADMIN_STATUES, url: PATH_ROUTING.PATH_SRM + '/' + PATH_ROUTING.PATH_ADMIN
          + '/' + PATH_ROUTING.PATH_GE_ADMIN_STATUES },
          { display: DISPLAY_BREADCRUMBS.GE_ADMIN_STATUS_UPDATE, url: '' },
          ],
          permissionCodes: [RSP_ROLES.ADMIN, RSP_ROLES.GE_TAG_ID_ADMIN, RSP_ROLES.SUPER_USER]
        },
        canActivate: [UserRolePermissionGuard]
      },
      {
        path: PATH_ROUTING.PATH_APPLICATION_ACCESS_ASSIGNMENT,
        component: AssignmentGroupManagementComponent,
        data: {
          breadcrumbs: [
            { display: DISPLAY_BREADCRUMBS.SRM, url: PATH_ROUTING.PATH_SRM + '/' + PATH_ROUTING.PATH_ADMIN },
            { display: DISPLAY_BREADCRUMBS.APPLICATION_ACCESS_ASSIGNMENT, url: '' },
          ],
          permissionCodes: [RSP_ROLES.ADMIN, RSP_ROLES.SUPER_USER, RSP_ROLES.OPERATOR_ACCESS, RSP_ROLES.GE_TAG_ID_ADMIN, RSP_ROLES.EOL_ADMIN],
        },
        canActivate: [UserRolePermissionGuard]
      },
      {
        path: PATH_ROUTING.PATH_APPLICATION_REVOKE_ASSIGNMENT,
        component: AssignmentGroupManagementComponent,
        data: {
          breadcrumbs: [
            { display: DISPLAY_BREADCRUMBS.SRM, url: PATH_ROUTING.PATH_SRM + '/' + PATH_ROUTING.PATH_ADMIN },
            { display: DISPLAY_BREADCRUMBS.APPLICATION_REVOKE_ASSIGNMENT, url: '' },
          ],
          permissionCodes: [RSP_ROLES.ADMIN, RSP_ROLES.SUPER_USER, RSP_ROLES.OPERATOR_ACCESS]
        },
        canActivate: [UserRolePermissionGuard]
      },
      {
        path: PATH_ROUTING.PATH_TRAINING_DOCUMENT_ADMIN,
        component: AdminComponent,
        data: {
          breadcrumbs: [
            { display: DISPLAY_BREADCRUMBS.SRM, url: PATH_ROUTING.PATH_SRM + '/' + PATH_ROUTING.PATH_ADMIN },
            { display: DISPLAY_BREADCRUMBS.TRAINING_DOCUMENT_ADMIN, url: PATH_ROUTING.PATH_TRAINING_DOCUMENT_ADMIN }
          ],
          permissionCodes: [RSP_ROLES.ADMIN, RSP_ROLES.SUPER_USER]
        },
        canActivate: [UserRolePermissionGuard]
      },
      {
        path: PATH_ROUTING.PATH_TRAINING_DOCUMENT_ADMIN_ADD,
        component: TrainingDocumentDetailComponent,
        data: {
          breadcrumbs: [
            { display: DISPLAY_BREADCRUMBS.SRM, url: PATH_ROUTING.PATH_SRM + '/' + PATH_ROUTING.PATH_ADMIN },
            { display: DISPLAY_BREADCRUMBS.TRAINING_DOCUMENT_ADMIN, url: PATH_ROUTING.PATH_SRM + '/' + PATH_ROUTING.PATH_ADMIN
            + '/' + PATH_ROUTING.PATH_TRAINING_DOCUMENT_ADMIN },
            { display: DISPLAY_BREADCRUMBS.ADD_ADMIN, url: '' }
          ],
          permissionCodes: [RSP_ROLES.ADMIN, RSP_ROLES.SUPER_USER]
        },
        canActivate: [UserRolePermissionGuard]
      },
      {
        path: PATH_ROUTING.PATH_TRAINING_DOCUMENT_ADMIN_EDIT,
        component: TrainingDocumentDetailComponent,
        data: {
          breadcrumbs: [
            { display: DISPLAY_BREADCRUMBS.SRM, url: PATH_ROUTING.PATH_SRM + '/' + PATH_ROUTING.PATH_ADMIN },
            { display: DISPLAY_BREADCRUMBS.TRAINING_DOCUMENT_ADMIN, url: PATH_ROUTING.PATH_SRM + '/' + PATH_ROUTING.PATH_ADMIN
            + '/' + PATH_ROUTING.PATH_TRAINING_DOCUMENT_ADMIN },
            { display: DISPLAY_BREADCRUMBS.EDIT_ADMIN, url: '' }
          ],
          permissionCodes: [RSP_ROLES.ADMIN, RSP_ROLES.SUPER_USER]
        },
        canActivate: [UserRolePermissionGuard]
      },
      {
        path: PATH_ROUTING.PATH_GE_CONFIDENTIAL_DOCUMENTS_ADMIN,
        component: AdminComponent,
        data: {
          breadcrumbs: [
            { display: DISPLAY_BREADCRUMBS.SRM, url: PATH_ROUTING.PATH_SRM + '/' + PATH_ROUTING.PATH_ADMIN },
            { display: DISPLAY_BREADCRUMBS.GE_CONFIDENTIAL_DOCUMENTS_ADMIN, url: PATH_ROUTING.PATH_GE_CONFIDENTIAL_DOCUMENTS_ADMIN }
          ],
          permissionCodes: [RSP_ROLES.ADMIN, RSP_ROLES.SUPER_USER]
        },
        canActivate: [UserRolePermissionGuard]
      },
      {
        path: PATH_ROUTING.PATH_GE_CONFIDENTIAL_DOCUMENTS_ADMIN_ADD,
        component: TrainingDocumentDetailComponent,
        data: {
          breadcrumbs: [
            { display: DISPLAY_BREADCRUMBS.SRM, url: PATH_ROUTING.PATH_SRM + '/' + PATH_ROUTING.PATH_ADMIN },
            { display: DISPLAY_BREADCRUMBS.TRAINING_DOCUMENT_ADMIN, url: PATH_ROUTING.PATH_SRM + '/' + PATH_ROUTING.PATH_ADMIN
            + '/' + PATH_ROUTING.PATH_GE_CONFIDENTIAL_DOCUMENTS_ADMIN },
            { display: DISPLAY_BREADCRUMBS.ADD_GE_CONFIDENTIAL_DOCUMENTS_ADMIN, url: '' }
          ],
          permissionCodes: [RSP_ROLES.ADMIN, RSP_ROLES.SUPER_USER]
        },
        canActivate: [UserRolePermissionGuard]
      },
      {
        path: PATH_ROUTING.PATH_GE_CONFIDENTIAL_DOCUMENTS_ADMIN_EDIT,
        component: TrainingDocumentDetailComponent,
        data: {
          breadcrumbs: [
            { display: DISPLAY_BREADCRUMBS.SRM, url: PATH_ROUTING.PATH_SRM + '/' + PATH_ROUTING.PATH_ADMIN },
            { display: DISPLAY_BREADCRUMBS.GE_CONFIDENTIAL_DOCUMENTS_ADMIN, url: PATH_ROUTING.PATH_SRM + '/' + PATH_ROUTING.PATH_ADMIN
            + '/' + PATH_ROUTING.PATH_GE_CONFIDENTIAL_DOCUMENTS_ADMIN },
            { display: DISPLAY_BREADCRUMBS.EDIT_GE_CONFIDENTIAL_DOCUMENTS_ADMIN, url: '' }
          ],
          permissionCodes: [RSP_ROLES.ADMIN, RSP_ROLES.SUPER_USER]
        },
        canActivate: [UserRolePermissionGuard]
      },
      {
        path: PATH_ROUTING.PATH_STAY_INFORMED_ADMIN,
        component: StayInformedAdminComponent,
        data: {
          breadcrumbs: [
            { display: DISPLAY_BREADCRUMBS.SRM, url: PATH_ROUTING.PATH_SRM + '/' + PATH_ROUTING.PATH_ADMIN },
            { display: DISPLAY_BREADCRUMBS.STAY_INFORMED_ADMIN, url: '' },
          ],
          permissionCodes: [RSP_ROLES.ADMIN, RSP_ROLES.SUPER_USER]
        },
        canActivate: [UserRolePermissionGuard]
      },
      {
        path: PATH_ROUTING.PATH_ADD_STAY_INFORMED_ADMIN,
        component: CreateEditStayInformedComponent,
        data: {
          breadcrumbs: [
            { display: DISPLAY_BREADCRUMBS.SRM, url: PATH_ROUTING.PATH_SRM + '/' + PATH_ROUTING.PATH_ADMIN },
            { display: DISPLAY_BREADCRUMBS.STAY_INFORMED_ADMIN, url: PATH_ROUTING.PATH_SRM + '/' + PATH_ROUTING.PATH_ADMIN + '/' +
            PATH_ROUTING.PATH_STAY_INFORMED_ADMIN },
            { display: DISPLAY_BREADCRUMBS.ADD_STAY_INFORMED_ADMIN, url: '' }
          ],
          permissionCodes: [RSP_ROLES.ADMIN, RSP_ROLES.SUPER_USER]
        },
        canActivate: [UserRolePermissionGuard]
      },
      {
        path: PATH_ROUTING.PATH_EDIT_STAY_INFORMED_ADMIN,
        component: CreateEditStayInformedComponent,
        data: {
          breadcrumbs: [
            { display: DISPLAY_BREADCRUMBS.SRM, url: PATH_ROUTING.PATH_SRM + '/' + PATH_ROUTING.PATH_ADMIN },
            { display: DISPLAY_BREADCRUMBS.STAY_INFORMED_ADMIN, url: PATH_ROUTING.PATH_SRM + '/' + PATH_ROUTING.PATH_ADMIN + '/' +
            PATH_ROUTING.PATH_STAY_INFORMED_ADMIN },
            { display: DISPLAY_BREADCRUMBS.EDIT_STAY_INFORMED_ADMIN, url: '' },
          ],
          permissionCodes: [RSP_ROLES.ADMIN, RSP_ROLES.SUPER_USER]
        },
        canActivate: [UserRolePermissionGuard]
      },
      {
        path: PATH_ROUTING.PATH_SCORECARD_SETTING,
        component: ScorecardSettingComponent,
        data: {
          breadcrumbs: [
            { display: DISPLAY_BREADCRUMBS.SRM, url: PATH_ROUTING.PATH_SRM + '/' + PATH_ROUTING.PATH_ADMIN },
            { display: DISPLAY_BREADCRUMBS.SCORECARD_SETTING, url: PATH_ROUTING.PATH_SRM + '/' + PATH_ROUTING.PATH_ADMIN + '/' +
            PATH_ROUTING.PATH_SCORECARD_SETTING },
          ],
          permissionCodes: [RSP_ROLES.ADMIN, RSP_ROLES.SUPER_USER, RSP_ROLES.OPERATOR_INFO]
        },
        canActivate: [UserRolePermissionGuard]
      },
      {
        path: PATH_ROUTING.PATH_ADD_SCORECARD_SETTING,
        component: CreateEditScorecardSettingComponent,
        data: {
          breadcrumbs: [
            { display: DISPLAY_BREADCRUMBS.SRM, url: PATH_ROUTING.PATH_SRM + '/' + PATH_ROUTING.PATH_ADMIN },
            { display: DISPLAY_BREADCRUMBS.SCORECARD_SETTING, url: PATH_ROUTING.PATH_SRM + '/' + PATH_ROUTING.PATH_ADMIN + '/' +
            PATH_ROUTING.PATH_SCORECARD_SETTING },
            { display: DISPLAY_BREADCRUMBS.ADD_SCORECARD_SETTING}
          ],
          permissionCodes: [RSP_ROLES.ADMIN, RSP_ROLES.SUPER_USER, RSP_ROLES.OPERATOR_INFO]
        },
        canActivate: [UserRolePermissionGuard]
      },
      {
        path: PATH_ROUTING.PATH_EDIT_SCORECARD_SETTING,
        component: CreateEditScorecardSettingComponent,
        data: {
          breadcrumbs: [
            { display: DISPLAY_BREADCRUMBS.SRM, url: PATH_ROUTING.PATH_SRM + '/' + PATH_ROUTING.PATH_ADMIN },
            { display: DISPLAY_BREADCRUMBS.SCORECARD_SETTING, url: PATH_ROUTING.PATH_SRM + '/' + PATH_ROUTING.PATH_ADMIN + '/' +
            PATH_ROUTING.PATH_SCORECARD_SETTING },
            { display: DISPLAY_BREADCRUMBS.EDIT_SCORECARD_SETTING}
          ],
          permissionCodes: [RSP_ROLES.ADMIN, RSP_ROLES.SUPER_USER, RSP_ROLES.OPERATOR_INFO]
        },
        canActivate: [UserRolePermissionGuard]
      },
      {
        path: PATH_ROUTING.PATH_EDIT_SCORECARD_SETTING_2,
        component: CreateEditScorecardSettingComponent,
        data: {
          breadcrumbs: [
            { display: DISPLAY_BREADCRUMBS.SRM, url: PATH_ROUTING.PATH_SRM + '/' + PATH_ROUTING.PATH_ADMIN },
            { display: DISPLAY_BREADCRUMBS.SCORECARD_SETTING, url: PATH_ROUTING.PATH_SRM + '/' + PATH_ROUTING.PATH_ADMIN + '/' +
            PATH_ROUTING.PATH_SCORECARD_SETTING },
            { display: DISPLAY_BREADCRUMBS.EDIT_SCORECARD_SETTING}
          ],
          permissionCodes: [RSP_ROLES.ADMIN, RSP_ROLES.SUPER_USER, RSP_ROLES.OPERATOR_INFO]
        },
        canActivate: [UserRolePermissionGuard]
      },
      {
        path: PATH_ROUTING.PATH_RATING_GUIDELINE,
        component: GeneralSettingsComponent,
        data: {
          breadcrumbs: [
            { display: DISPLAY_BREADCRUMBS.SRM, url: PATH_ROUTING.PATH_SRM + '/' + PATH_ROUTING.PATH_ADMIN },
            { display: DISPLAY_BREADCRUMBS.RATING_GUIDELINE},
          ],
          permissionCodes: [RSP_ROLES.ADMIN, RSP_ROLES.SUPER_USER, RSP_ROLES.OPERATOR_ACCESS, RSP_ROLES.OPERATOR_INFO, RSP_ROLES.SUPPLIER]
        },
        canActivate: [UserRolePermissionGuard]
      },
      {
        path: PATH_ROUTING.PATH_EOL_SETUPS,
        component: EolSetupsComponent,
        data: {
          breadcrumbs: [
            { display: DISPLAY_BREADCRUMBS.SRM, url: PATH_ROUTING.PATH_SRM + '/' + PATH_ROUTING.PATH_ADMIN },
            { display: DISPLAY_BREADCRUMBS.EOL_SETUPS},
          ],
          permissionCodes: [RSP_ROLES.ADMIN, RSP_ROLES.SUPER_USER, RSP_ROLES.EOL_ADMIN]
        },
        canActivate: [UserRolePermissionGuard]
      },
      {
        path: `${PATH_ROUTING.PATH_EOL_SETUPS_SUPPLIER_FORM}/:id`,
        component: EolSetupsFormComponent,
        data: {
          breadcrumbs: [
            { display: DISPLAY_BREADCRUMBS.SRM, url: PATH_ROUTING.PATH_SRM + '/' + PATH_ROUTING.PATH_ADMIN },
            { display: DISPLAY_BREADCRUMBS.EOL_SETUPS, url: PATH_ROUTING.PATH_SRM + '/' + PATH_ROUTING.PATH_ADMIN + '/' + PATH_ROUTING.PATH_EOL_SETUPS},
            { display: DISPLAY_BREADCRUMBS.SUPPLIER_FORM},
          ],
          permissionCodes: [RSP_ROLES.ADMIN, RSP_ROLES.SUPER_USER, RSP_ROLES.EOL_ADMIN]
        },
        canActivate: [UserRolePermissionGuard]
      },
      {
        path: PATH_ROUTING.PATH_EOL_SETUPS_SUPPLIER_FORM,
        component: EolSetupsFormComponent,
        data: {
          breadcrumbs: [
            { display: DISPLAY_BREADCRUMBS.SRM, url: PATH_ROUTING.PATH_SRM + '/' + PATH_ROUTING.PATH_ADMIN },
            { display: DISPLAY_BREADCRUMBS.EOL_SETUPS, url: PATH_ROUTING.PATH_SRM + '/' + PATH_ROUTING.PATH_ADMIN + '/' + PATH_ROUTING.PATH_EOL_SETUPS},
            { display: DISPLAY_BREADCRUMBS.SUPPLIER_FORM},

          ],
          permissionCodes: [RSP_ROLES.ADMIN, RSP_ROLES.SUPER_USER, RSP_ROLES.EOL_ADMIN]
        },
        canActivate: [UserRolePermissionGuard]
      },
      {
        path: `${PATH_ROUTING.PATH_EOL_SETUPS_FIBERGLASS}/:id`,
        component: EolSetupsFormComponent,
        data: {
          breadcrumbs: [
            { display: DISPLAY_BREADCRUMBS.SRM, url: PATH_ROUTING.PATH_SRM + '/' + PATH_ROUTING.PATH_ADMIN },
            { display: DISPLAY_BREADCRUMBS.EOL_SETUPS, url: PATH_ROUTING.PATH_SRM + '/' + PATH_ROUTING.PATH_ADMIN + '/' + PATH_ROUTING.PATH_EOL_SETUPS},
            { display: DISPLAY_BREADCRUMBS.FIBERGLASS_PROCESSING_FORM},
          ],
          permissionCodes: [RSP_ROLES.ADMIN, RSP_ROLES.SUPER_USER, RSP_ROLES.EOL_ADMIN]
        },
        canActivate: [UserRolePermissionGuard]
      },
      {
        path: PATH_ROUTING.PATH_EOL_SETUPS_FIBERGLASS,
        component: EolSetupsFormComponent,
        data: {
          breadcrumbs: [
            { display: DISPLAY_BREADCRUMBS.SRM, url: PATH_ROUTING.PATH_SRM + '/' + PATH_ROUTING.PATH_ADMIN },
            { display: DISPLAY_BREADCRUMBS.EOL_SETUPS, url: PATH_ROUTING.PATH_SRM + '/' + PATH_ROUTING.PATH_ADMIN + '/' + PATH_ROUTING.PATH_EOL_SETUPS},
            { display: DISPLAY_BREADCRUMBS.FIBERGLASS_PROCESSING_FORM},
          ],
          permissionCodes: [RSP_ROLES.ADMIN, RSP_ROLES.SUPER_USER, RSP_ROLES.EOL_ADMIN]
        },
        canActivate: [UserRolePermissionGuard]
      },
    ],
    data : {
      permissionCodes: [RSP_ROLES.ADMIN, RSP_ROLES.SUPER_USER, RSP_ROLES.OPERATOR_ACCESS, RSP_ROLES.OPERATOR_INFO,
        CONTRACT_ROLES.CONTRACT_ADMIN, DOCSTORE_ROLES.DOCSTORE_ADMIN, RSP_ROLES.GE_TAG_ID_ADMIN, RSP_ROLES.EOL_ADMIN]
    },
    canActivate: [UserRolePermissionGuard]
  },
];
